export type Membership = 'non-member' | 'member' | 'vip-member';

export const NON_MEMBER = 'non-member';
export const MEMBER = 'member';
export const VIP_MEMBER = 'vip-member';

export const PER_COIN = 1000;
